/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Box, Modal, Grid, Tooltip, IconButton } from '@mui/material';
import { Rnd } from 'react-rnd';
import CloseIcon from '@mui/icons-material/Close';
import AdminLogin from '../admin/AdminLogin';
import { defaultModalOptions, user1_email, user2_email, user3_email, user4_email } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { decrypt_data } from '../../shared/utils';
import './options.scss';

const Options = (props) => {
  const { openOption, handleCloseOption, adminBtnTxt, setAdminBtnTxt, mail_ID, userMail_ID_Access_Env } = props;
  const [, setAbFactor] = useState('0');
  const [, setOpenAB] = useState(false);
  const [adminFeature, setAdminFeature] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [adminLoginOption, setAdminLoginOption] = useState(false);
  const [adminEmailsList, setAdminEmailsList] = useState([]);
  const [adminUserCredentials, setAdminUserCredentials] = useState([]);

  useEffect(() => {
    const options = JSON.parse(localStorage.getItem('options'));
    const ab = get(options, 'abFactor', '0');
    setAbFactor(ab);
  }, []);

  const optionsData = [
    { label: 'A & B - Factors', id: 'a&b-factors', event: setOpenAB },
  ];
  const handleClickCard = (card) => {
    card.event(true);
  };
  const handleCloseOptionAdmin = () => {
    setAdminLoginOption(false);
    setAdminBtnTxt('Admin');
  };

  const adminList = (adminEmails) => {
    setAdminEmailsList(adminEmails);
  };
  // get Admin list
  useEffect(async () => {
    // sudarsana for access of Admin button only for specific user
    let winflows_db_auth_dict = [];

    const admin_pwd_enc = process.env.REACT_APP_ADMIN_PWD;
    const admin_pwd = decrypt_data(admin_pwd_enc);

    if (process.env.REACT_APP_ENV === 'dev') {
      if (localStorage.getItem('winflows_db_auth_dict')) {
        winflows_db_auth_dict = Object.values(JSON.parse(localStorage.getItem('winflows_db_auth_dict')));
      }
      else {
        winflows_db_auth_dict = [
          {
            employee_email: user1_email,
            authentication_pwd: admin_pwd
          },
          {
            employee_email: user2_email,
            authentication_pwd: admin_pwd
          },
          {
            employee_email: user3_email,
            authentication_pwd: admin_pwd
          },
          {
            employee_email: user4_email,
            authentication_pwd: admin_pwd
          }
        ];
      }
    } else if (process.env.REACT_APP_ENV === 'qa') {
      winflows_db_auth_dict = [
        {
          employee_email: user1_email,
          authentication_pwd: admin_pwd
        },
        {
          employee_email: user2_email,
          authentication_pwd: admin_pwd
        }
      ];
    } else if (process.env.REACT_APP_ENV === 'prod') {
      winflows_db_auth_dict = [
        {
          employee_email: user2_email,
          authentication_pwd: admin_pwd
        }
      ];
    }
    setAdminUserCredentials(winflows_db_auth_dict);
    // check the logined User present in admin user list or not
    const adminEmails = winflows_db_auth_dict.map(emp => emp.employee_email);
    setAdminFeature(userMail_ID_Access_Env.includes(mail_ID));   // Set the adminAcess only For Anitha
    adminList(adminEmails);
  }, []);

  const authenticateAdmin = async () => {
    const userId = sessionStorage.getItem('user_email');
    if (adminEmailsList.includes(userId)) {
      setAdminBtnTxt('Winflows DB');
      setAdminLoginOption(true);
    } else {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Error',
        message: 'You dont have permission to access Admin module',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
        type: 'error'
      });
    }
  };

  return (
    <>
      <Modal
        hideBackdrop
        open={openOption}
        onClose={handleCloseOption}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="options-modal"
      >
        <Box className=''>
          <Rnd
            default={{
              width: '75%',
              x: ((window.innerWidth / 2) - ((75 * (window.innerWidth / 100)) / 2)),
              y: ((window.innerHeight / 2) - ((40 * (window.innerHeight / 100)) / 2)),
            }}
            enableResizing={{
              bottom: false, bottomLeft: false, bottomRight: false,
              left: true, right: true,
              top: false, topLeft: false, topRight: false
            }}
            allowAnyClick={false}
            enableUserSelectHack={false}
            resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
            minWidth='47%'
            cancel=".no_drag"
            className='options-box options-width'>
            <Notification
              options={modalOption}
              handleClose={() => setModalOption(defaultModalOptions)}
            />
            <Grid container className='options-grid-container'>
              <Grid item xs={12} className='options-header-grid'>
                <div className='options-header-text rufusBld no_drag'>Options</div>
                <div className='options-close-icon no_drag'>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="save"
                      onClick={handleCloseOption}
                      size="large"
                      className="close-icon">
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              {/* hidden by  Abhishek on 21-nov-23 :-> to remove AB Value factor from option tab */}
              {false && <Grid item xs={6} className='options-content-grid options-height'>
                <Grid container>
                  <Grid item xs={12}>
                    <div className="card-container">
                      {(optionsData || []).map((obj) => (
                        <div className="options-card" onClick={() => handleClickCard(obj)}>
                          <div className="card-text">{obj.label}</div>
                        </div>
                      ))}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              }
              <Grid item xs={6} className='options-content-grid options-height'>
                <Grid container>
                  <Grid item xs={12}>
                    {/* if env is dev and adminFeature is true by Abhishek 8-Dec-23 */}
                    {/* @ sudarsana for access of Admin button only for specific user  && adminFeature */}
                    {((process.env.REACT_APP_ENV === 'dev' ||
                      (process.env.REACT_APP_ENV === 'qa') ||
                      (process.env.REACT_APP_ENV === 'prod')) && adminFeature) &&
                      <div className="card-container">
                        <div className="options-card" onClick={() => authenticateAdmin()}>
                          <div className="card-text">{adminBtnTxt}</div>
                        </div>
                      </div>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Rnd>
        </Box>
      </Modal>
      {adminLoginOption && (
        <AdminLogin
          adminLoginOption={adminLoginOption}
          handleCloseOption={handleCloseOptionAdmin}
          setAdminLoginOption={setAdminLoginOption}
          adminUserCredentials={adminUserCredentials}
        />
      )}
    </>
  );
};

export default Options;
